import React from "react";

import { useState } from "react";
import Login from "./Login";
import theme from "../theme";
import { ThemeProvider } from "@mui/material/styles";
import License from "./License";
import MyLicenseForm from "./MyLicenseForm";
import TitleWithDropdown from "./TitleWithDropdown";
import { useDispatch, useSelector } from "react-redux";
import image from "../logos/license.png";
import "./CommonDashboard.css";
import axios from "axios";

import { setLicense } from "../redux/slices/licenseSlice";

function LicenseDashboard() {
  const api = localStorage.getItem("api");
  const [login, setLogin] = useState(false);
  const dispatch = useDispatch();

  const headers = useSelector((state) => state.header);

  const [errors, setErrors] = useState(false);

  React.useEffect(() => {
    axios
      .get(api + `/list/license`, {
        headers: headers.headers,
      })
      .then((response) => {
        if (response?.data?.length === 0) {
          setErrors(true);
        } else {
          dispatch(setLicense(response.data));
          setErrors(false);
        }
      })
      .catch((error) => {});
  }, []);

  return login == null ? (
    <Login />
  ) : (
    <>
      <ThemeProvider theme={theme}>
        <div className="mainContainer emms-main-container">
          <header className="no-margin">
            <figure>
              <img className="img" src={image} alt="Logo" />
            </figure>
          </header>
          <div className="title-container">
            <div className="title">
              <TitleWithDropdown title="Licenses" />
            </div>
            <div>
              <MyLicenseForm />
            </div>
          </div>
          <div className="emms-main-container-left-align"  style={{ marginLeft: "10%" }}>
            <License errors={errors} />
          </div>
        </div>
      </ThemeProvider>
    </>
  );
}

export default LicenseDashboard;
